import { useEffect, useState } from "react";
import { getValidationScoringConfigById } from "../services/scoringService";

const useFetchValidationScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});
  useEffect(() => {
    if (configId && configId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getValidationScoringConfigById(configId);
          setConfigData(result);
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]);

  return [configData];
};

export default useFetchValidationScoringConfigById;

